import Vue from 'vue'
import index from './index.vue'
import router from '@/router'
import store from '@/store'

import '@/assets/styles/basic.scss'
import '@/assets/styles/global.scss'
import '@/assets/styles/atom.scss'
import '@/assets/styles/auth.scss'

import directive from '@/utils/directive'
import utils from '@/utils/utils'
import filter from '@/utils/filter'
import Vtip from 'vtip'
import 'vtip/lib/index.min.css'

import Components from '@/components'

import LUi from '@linkkap/l-ui'
import '@linkkap/l-ui/lib/l-ui.css'
Vue.use(LUi)

directive.init(Vue)
filter.init(Vue)

Vue.config.productionTip = false
Vue.use(Components)
Vue.use(Vtip.directive)

Vue.use({
  install(Vue) {
    Vue.prototype.$toPage = function(val, obj) {
      if (typeof val === 'object') {
        obj = val
        val = this.$router.path
      }
      setTimeout(() => {
        this.$router.push({
          path: val,
          query: obj || {}
        })
      }, 0)
    }
    Vue.prototype.$utils = utils
  }
})
new Vue({
  router,
  store,
  render: h => h(index),
}).$mount('#app')
